import styled from "styled-components"

export const Component = styled.div<{ $k: number }>`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04),
    0 2px 8px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.25s ease, transform 0.25s ease;

  a {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: 100%;
    cursor: pointer;
    color: inherit;

    &:focus-visible {
      outline: 2px solid ${({ theme }) => theme.colors.blue.main};
      outline-offset: 3px;
      border-radius: 12px;
    }
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.12),
      0 2px 6px rgba(15, 23, 42, 0.06);
    transform: translateY(-4px);
  }

  &:hover img {
    transform: scale(1.04);
  }

  &:active {
    transform: translateY(-2px) scale(0.995);
  }

  opacity: 0;
  ${({ $k, theme }) =>
    theme.animations.types.fadeLeft +
    theme.animations.durations.main +
    theme.animations.delays.main($k)}
`

export const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 2;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-color: #f4f6f8;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
  }
`

export const EventInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 16px 14px;
`

export const EventName = styled.span`
  font-size: 18px;
  color: #1a1f2e;
  font-weight: 700;
  line-height: 1.3;
  min-height: calc(1.3em * 2);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const CardBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  min-height: 28px;
`

export const EventDate = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #475569;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    color: #64748b;
  }
`

export const GoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background-color: rgba(0, 97, 230, 0.08);
  color: ${({ theme }) => theme.colors.blue.main};
  flex-shrink: 0;
  transition: background-color 0.2s ease, transform 0.25s ease;

  svg {
    width: 16px;
    height: 16px;
  }

  ${Component}:hover & {
    background-color: ${({ theme }) => theme.colors.blue.main};
    color: #ffffff;
    transform: translateX(2px);
  }
`
